<template>
    <div >
      <div class="solution_warp">
        <div class="solution_banner">
          <div class="solution_banner_title">
            <h2 class="">{{$t('solution.Excavating')}}</h2>
            <h3>{{$t('solution.Industry')}}</h3>
          </div>
        </div>
        <div id="market" class="tvAi_warp">
          <div class="tvAi_top clearfix">
            <div class="tvAi_top_title">
              <h2>{{$t('solution.Marketing')}}</h2>
              <p class="tvAi_top_title2">{{$t('solution.Intelligent')}}</p>
              <p class="tvAi_top_p">{{$t('solution.Effective')}}</p>
            </div>
            <div class="tvAi_video">
              <img src="http://bu.dressplus.cn/web/static/image/Market_image02.jpg" alt="">
              <a href="javascript:;" class="video_warp" @click="showVideo(1)"><img src="http://bu.dressplus.cn/web/static/image/tv+AI_video.png" alt=""></a>
            </div>
          </div>
          <div class="tvAi_bottom">
            <h2 style="">{{$t('solution.Relevant')}}</h2>
            <p style="">
              {{$t('solution.Advertisers')}}、{{$t('solution.Advertising')}}、{{$t('solution.Video')}}、{{$t('solution.Livestream')}}、{{$t('solution.Short')}}、{{$t('solution.Browsers')}}、{{$t('solution.Search')}}、{{$t('solution.Platforms')}}
            </p>
            <ul class=" market_bottom_list clearfix">
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market01.png" alt="">
                <p>{{$t('solution.Structured')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market02.png" alt="">
                <p>{{$t('solution.Scenario')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market03.png" alt="">
                <p>{{$t('solution.ImageSearch')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market04.png" alt="">
                <p>{{$t('solution.SearchByImage')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market05.png" alt="">
                <p>{{$t('solution.Personalized')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/Market06.png" alt="">
                <p>{{$t('solution.Face')}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div id="tv" class="tvAi_warp tvAi_warp1">
          <div class="tvAi_top clearfix">
            <div class="tvAi_top_title">
              <h2>{{$t('solution.Television')}}</h2>
              <p class="tvAi_top_title2">{{$t('solution.Communication')}}</p>
              <p class="tvAi_top_p">{{$t('solution.propelled')}}</p>
            </div>
            <div class="tvAi_video">
              <img src="http://bu.dressplus.cn/web/static/image/Tv+AIimage01.jpg" alt="">
              <a href="javascript:;" class="video_warp" @click="showVideo(2)"><img src="http://bu.dressplus.cn/web/static/image/tv+AI_video.png" alt=""></a>
            </div>
          </div>
          <div class="tvAi_bottom">
            <h2 style="">{{$t('solution.Relevant')}}</h2>
            <p style="">IPTV/OTT/、{{$t('solution.Smart')}}</p>
            <ul class="tvAi_bottom_list clearfix">
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/tv01.png" alt="">
                <p>{{$t('solution.Assistant')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/tv02.png" alt="">
                <p>{{$t('solution.Televised')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/tv03.png" alt="">
                <p>{{$t('solution.Valueadded')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/tv04.png" alt="">
                <p>{{$t('solution.Extraction')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/tv05.png" alt="">
                <p>{{$t('solution.Broadcasting')}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div id="camera" class="camera_warp">
          <div class="tvAi_top clearfix">
            <div class="tvAi_top_title">
              <h2>{{$t('solution.CameraAi')}}</h2>
              <p class="tvAi_top_title2">{{$t('solution.Creative')}}</p>
              <p class="tvAi_top_p">{{$t('solution.future')}}</p>
            </div>
            <div class="tvAi_video">
              <img src="http://bu.dressplus.cn/web/img/yi_camera.jpg" alt="">
              <a href="javascript:;" class="video_warp" @click="showVideo(3)"><img src="http://bu.dressplus.cn/web/static/image/tv+AI_video.png" alt=""></a>
            </div>
          </div>
          <div class="tvAi_bottom">
            <h2 style="">{{$t('solution.Relevant')}}</h2>
            <p style="">{{$t('solution.Camera')}}、{{$t('solution.Photo')}}</p>
            <ul class="tvAi_bottom_list clearfix">
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/camera01.png" alt="">
                <p>{{$t('solution.SmartPhoto')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/camera02.png" alt="">
                <p>{{$t('solution.Virtual')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/camera03.png" alt="">
                <p>{{$t('solution.Dynamic')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/camera04.png" alt="">
                <p>{{$t('solution.Shopping')}}</p>
              </li>
              <li>
                <img src="http://bu.dressplus.cn/web/static/image/camera05.png" alt="">
                <p>{{$t('solution.Realtime')}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="video_tan" v-if="showVideoTan" @click.self="hidVideo">
        <video  class="video" controls="controls" autoplay="autoplay" ><source :src="videoSrc" type="video/mp4"></video>
      </div>
    </div>
</template>

<script>
	import bus from '../utils/bus'

	export default {
      data(){
        return{
          showVideoTan:false,
          videoSrc:'',
        }
      },
	    mounted(){
		    bus.$emit('customEvent','solution');
	    },
      methods:{
        showVideo(index){
          if (index === 1){
            this.showVideoTan = true
            this.videoSrc = 'http://bu.dressplus.cn/web/video/%E8%90%A5%E9%94%80%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4'
          }else if (index === 2){
            this.showVideoTan = true
            this.videoSrc = 'http://bu.dressplus.cn/web/video/%E5%A4%A7%E5%B1%8F%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4'
          }else if (index === 3){
            this.showVideoTan = true
            this.videoSrc = 'http://bu.dressplus.cn/web/video/yi_camera.mp4'
          }
        },
        hidVideo(){
          this.showVideoTan = false
        }
      }
    }
</script>

<style>
  @media screen and (min-width: 768px){
    .solution_warp{
      position: relative;
    }
    .solution_banner{
      background: url("http://bu.dressplus.cn/web/static/image/solution_bj1.jpg") center no-repeat;
      height: 840px;
      position: relative;
    }
    .solution_banner_title{
      width: 100%;
      text-align: center;
      position: absolute;
      top: 52%;
    }
    .solution_banner_title>h2{
      font-size: 48px;
      color: #343d42;
    }
    .solution_banner_title>h3{
      margin-top: 48px;
      font-size: 72px;
      color: #333;
    }
    .tvAi_warp1{
      background: #F2F2F2;
    }
    .tvAi_top{
      width: 70%;
      margin: 0 auto;
      padding: 100px 0px 90px 0;
    }
    .tvAi_top>div{
    }
    .tvAi_top_title{
      width: 50%;
      float: left;
      padding-top: 6%;
    }
    .tvAi_top_title>h2{
      font-size: 48px;
      color: #00a6ff;
    }
    .tvAi_video{
      float: right;
      width: 50%;
      position: relative;
    }
    .tvAi_video>img{
      vertical-align: middle;
      width: 100%;
    }
    .video_warp{
      width: 58px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -29px;
      margin-left: -29px;
    }
    .video_warp>img{
      vertical-align: middle;
    }
    .tvAi_video_btn{
      position: absolute;
      bottom: 0;
      left: 0;
      display: inline-block;
      width: 168px;
      height: 48px;
      background: #00a6ff;
      color: #fff;
      font-size: 17px;
      line-height: 48px;
      text-align: center;
    }
    .tvAi_video_btn>span{
      transform: rotate(90deg);
      display: inline-block;
      vertical-align: middle;
      font-size: 18px;
    }
    .tvAi_top_title2{
      font-size: 22px;
      color: #535353;
      margin: 30px 0px 60px 0;
    }
    .tvAi_top_p{
      line-height: 35px;
      font-size: 17px;
      color: #999;
      width: 86%;
    }
    .tvAi_bottom{
      width: 70%;
      margin: 0 auto;
      text-align: center;
    }
    .tvAi_bottom>h2{
      color: #333;
      font-size: 22px;
      padding: 2px 0px 30px 0
    }
    .tvAi_bottom>p{
      color: #999;
      font-size: 17px
    }
    .tvAi_bottom_list{

    }
    .tvAi_bottom_list>li{
      float: left;
      width: 20%;
    }
    .tvAi_bottom_list img{
      min-width: 70px;
      width: 30%;
      margin: 50px 0 30px 0;
    }
    .tvAi_bottom_list p{
      font-size: 18px;
      color: #666;
      margin-bottom: 60px;
    }

    .camera_warp{
      background: #fff;
    }
    .market_bottom_list li{
      float: left;
      width: 16.66%;
    }
    .market_bottom_list img{
      min-width: 70px;
      width: 30%;
      margin: 50px 0 30px 0;
    }
    .market_bottom_list p{
      font-size: 18px;
      color: #666;
      margin-bottom: 60px;
    }
    .video_tan{
      position: fixed;
      width: 100%;
      z-index: 10001;
      top: 0;
      bottom: 0;
      background-color: rgba(0,0,0,.6);
    }
    .video_tan>.video{
      width: 35%;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -10%;
      margin-left: -17%;
    }
  }
  @media screen and (max-width: 767px){
    .solution_warp{
      position: relative;
      padding-top: 1.18rem;
      text-align: center;
    }
    .solution_banner{
      background: url("http://bu.dressplus.cn/web/static/image/solution_bj1.jpg") center no-repeat;
      height: 4.37rem;
      position: relative;
      background-size: 100% 100%;
    }
    .solution_banner_title{
      width: 100%;
      text-align: center;
      position: absolute;
      top: 52%;
    }
    .solution_banner_title>h2{
      font-size: 0.32rem;
      color: #343d42;
    }
    .solution_banner_title>h3{
      font-size: 0.51rem;
      font-weight: 600;
      color: #333;
      margin-top: 0.3rem;
    }
    .tvAi_warp{
    }
    .tvAi_warp1{
      background: #F2F2F2;
    }
    .tvAi_top{
      width: 85%;
      margin: 0 auto;
      padding: 1rem 0px 1rem 0;
    }
    .tvAi_top>div{
    }
    .tvAi_top_title{
    }
    .tvAi_top_title>h2{
      color: #00a6ff;
      font-size: 0.45rem;
    }
    .tvAi_video{
      position: relative;
      margin-top: 0.6rem;
    }
    .video_warp{
      width: 0.78rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -0.39rem;
      margin-top: -0.39rem;
    }
    .video_warp>img{
      width: 100%;
    }
    .tvAi_video>img{
      vertical-align: middle;
      width: 100%;
    }
    .tvAi_top_title2{
      font-size: 0.37rem;
      color: #333;
      margin: 0.4rem 0px 0.6rem 0;
    }
    .tvAi_top_p{
      line-height: 0.52rem;
      font-size: 0.3rem;
      color: #666;
    }
    .tvAi_bottom{
      width: 90%;
      margin: 0 auto;
      text-align: center;
    }
    .tvAi_bottom>h2{
      color: #333;
      font-size: 0.37rem;
    }
    .tvAi_bottom>p{
      color: #666;
      font-size: 0.29rem;
      line-height: 0.5rem;
      margin-top: 0.3rem;
      margin-bottom: 0.3rem;
    }
    .tvAi_bottom_list{

    }
    .tvAi_bottom_list>li{
      float: left;
      width: 50%;
    }
    .tvAi_bottom_list img{
      min-width: 1rem;
      width: 30%;
      margin: 0.5rem 0 0.2rem 0;
    }
    .tvAi_bottom_list p{
      font-size: 0.29rem;
      color: #666;
      margin-bottom: 0.5rem;
    }

    /*.camera_warp{
      background: #F2F2F2;
    }*/
    .market_bottom_list li{
      float: left;
      width: 50%;
    }
    .market_bottom_list img{
      min-width: 1rem;
      width: 30%;
      margin: 0.5rem 0 0.2rem 0;
    }
    .market_bottom_list p{
      font-size: 0.29rem;
      color: #666;
      margin-bottom: 0.5rem;
    }
    .video_tan{
      position: fixed;
      width: 100%;
      z-index: 10001;
      top: 0;
      bottom: 0;
      background-color: rgba(0,0,0,.6);
    }
    .video_tan>.video{
      width: 100%;
      position: absolute;
      top: 50%;
      margin-top: -25%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/solution.vue